import { Component } from '@angular/core';
import { IFloatingFilter } from 'ag-grid-community';

@Component({
  selector: 'app-dropdown-field-filter',
  templateUrl: './dropdown-field-filter.component.html',
  styleUrl: './dropdown-field-filter.component.css'
})
export class DropdownFieldFilterComponent implements IFloatingFilter {
  params!: any;
  currentValue: any;
  style: any;
  optionsList: string[] = []
  currentField!: string
  selectedValue!: any

  agInit(params: any): void {
    this.params = params;
    const filterdModel = this.params.api

    this.currentField = this.params.column.colId
    if (filterdModel[this.currentField] != undefined || filterdModel[this.currentField] != null) {  //NOSONAR 
      if (filterdModel[this.currentField]?.filter.length !== 0) {
        this.selectedValue = filterdModel[this.currentField].filter
      }
      else {
        this.selectedValue = null
      }
    }
    this.optionsList = this.optionsList.concat(this.params.associatedList)
    this.style = {
      color: params.color,
    };
  }

  onParentModelChanged(parentModel: any) { //NOSONAR
    // When the filter is empty we will receive a null value here
    if (parentModel === null) { this.selectedValue = null }
    if (!parentModel) {
      this.selectedValue = "All";
    } else {
      this.selectedValue = parentModel.filter
    }
  }

  onChangeFilter(event: any) { //NOSONAR
    this.selectedValue = event.target?.value;
    const filterdModel = this.params.api.getFilterModel()
    if ((this.currentField === 'uniontype') || (this.currentField === 'legitimizationstatus') || (this.currentField === 'unionstatus') || (this.currentField === 'evaluation') ||
      (this.currentField === 'monthlyconfirmation') || (this.currentField === 'contingencyplan') || (this.currentField === 'bankbuildverifiedbyn1') || (this.currentField === 'bankbuildoncontingencyplan')) {
      let filterVal = ""
      if (this.selectedValue !== "All") {
        filterVal = this.selectedValue
      }
      filterdModel[this.currentField] = { type: 'equals', filter: filterVal, filterType: 'text' }
      this.params.api.setFilterModel(filterdModel);
    } else {
      filterdModel[this.currentField] = { type: 'equals', filter: this.selectedValue, filterType: 'text' }
      this.params.api.setFilterModel(filterdModel);
    }
  }
}
